import {
  Dialog,
  DialogContent,
  makeStyles,
  IconButton,
  CircularProgress,
} from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CloseIcon from '@material-ui/icons/Close'
import ButtonSp from '../ui/ButtonSp'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    padding: `${theme.spacing(7)}px ${theme.spacing(7)}px ${theme.spacing(
      7
    )}px ${theme.spacing(7)}px !important`,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(
        2
      )}px ${theme.spacing(2)}px !important`,
    }
  },
  icon: {
    width: 80,
    height: 80,
  },
  greenIcon: {
    color: '#219653',
  },
  redIcon: {
    color: 'red',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(4),
    right: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
  },
  title: {
    fontWeight: 500,
    fontSize: 22,
    color: '#404041',
    marginBottom: theme.spacing(3),
    ...theme.headerFont,
  },
  subtitle: {
    fontWeight: 400,
    fontSize: 16,
    color: '#404041',
    marginTop: 0,
    marginBottom: theme.spacing(4),
  },
  button: {
    ...theme.homeStyle.button,
  },
}))

// this is named success modal but is success modal, error modal, progress modal
const SuccessModal = ({
  isOpen,
  setOpen,
  title,
  subtitle,
  type = 'success',
  progress,
}) => {
  const classes = useStyles()
  const { t } = useTranslation('common')

  const renderIcon = () => {
    switch (type) {
      case 'success':
        return <DoneIcon className={clsx(classes.icon, classes.greenIcon)} />
      case 'error':
        return (
          <HighlightOffIcon className={clsx(classes.icon, classes.redIcon)} />
        )
      case 'progress':
        return (
          <CircularProgress value={progress} variant="determinate" size={80} />
        )
      default:
        return null
    }
  }

  return (
    <Dialog onClose={() => setOpen(false)} open={isOpen} maxWidth="lg">
      <DialogContent className={classes.content}>
        {type !== 'progress' && (
          <IconButton
            className={classes.closeButton}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        )}
        {renderIcon()}
        <h2 className={classes.title}>{title}</h2>
        <h3 className={classes.subtitle}>{subtitle}</h3>
        {type !== 'progress' && (
          <ButtonSp className={classes.button} onClick={() => setOpen(false)}>
            {t('okay')}
          </ButtonSp>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default SuccessModal
